import RestService from '../services/rest';

async function getListSupplierAutomation(limit, skip, search, orderBy, field) {
  return RestService.getAuthenticated(
    `panel/supplierAutomation/list?limit=${limit}&skip=${skip}&search=${search}&orderBy=${orderBy}&field=${field}`,
  );
}

async function createSupplierAutomation(newSupplierAutomation) {
  return RestService.postAuthenticated(
    'panel/supplierAutomation/create', newSupplierAutomation,
  );
}

async function updateSupplierAutomation(updSupplierAutomation) {
  return RestService.putAuthenticated(
    'panel/supplierAutomation/update', updSupplierAutomation,
  );
}

export default {
  getListSupplierAutomation,
  createSupplierAutomation,
  updateSupplierAutomation,
};
